import React, { FC } from 'react';
import styled from 'styled-components';
import { NewRow } from 'components/molecules/new-row';
import { Task } from 'data/tasks';

export const AddTaskInternal = styled(NewRow)`
  .icon-shell {
    margin-left: var(--layout-02);
  }

  input {
    background: transparent;
  }
`;

interface Props {
  id: string;
  onCreate?: (task: Task) => void;
  onCreateMultiple?: (task: Task[]) => void;
  autoFocus?: boolean;
}

export const AddTask: FC<Props> = ({
  id,
  onCreate,
  onCreateMultiple,
  autoFocus,
}) => (
  <AddTaskInternal
    id={id}
    size="small"
    autoFocus={autoFocus}
    // TODO: Translate
    placeholder="Add new task"
    onAdd={(taskName) => {
      onCreate?.({ taskName } as unknown as Task);

      return Promise.resolve();
    }}
    onAddMultiple={(tasks) => {
      onCreateMultiple?.(tasks as unknown as Task[]);

      return Promise.resolve();
    }}
    bulkAddType="tasks"
  />
);
